query getDunningLevelForCompany($companyId: ID!) {
  dunningLevel: getDunningLevelForCompany(companyId: $companyId)
}
